import { HttpClient } from 'api/http-client';
import { TimeoffHistory, Timeoff, TimeoffResponse } from './types';

class TimeoffHttpClient extends HttpClient {
  public getTimeoffHistory(): Promise<Array<TimeoffHistory>> {
    return this.get('time-off');
  }

  public createTimeoff(payload: Timeoff): Promise<TimeoffResponse> {
    return this.post('/time-off', payload);
  }

  public deleteTimeoff(timeOffId: number): Promise<TimeoffResponse> {
    return this.delete(`/time-off/${timeOffId}`);
  }
}

export const TimeoffAPI = new TimeoffHttpClient();
